export default function observeIntersection(el, callback, once, thresh, root, rootm) {
    const options = {
        root,
        rootMargin: rootm,
        threshold: thresh,
    };
    const elContainer = document.querySelectorAll(el);
    const elObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                callback(entry, true);
                if (once) {
                    elObserver.unobserve(entry.target);
                }
            } else {
                callback(entry, false);
            }
        });
    }, options);
    elContainer.forEach((target) => {
        elObserver.observe(target);
    });
}
